import { render, staticRenderFns } from "./dataAuthority.vue?vue&type=template&id=d51928ae"
import script from "./dataAuthority.vue?vue&type=script&lang=js"
export * from "./dataAuthority.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports